import { Component, inject } from "@angular/core";
import {
  FormControl,
  Validators,
} from "@angular/forms";
import { ThemePalette } from "@angular/material/core";
import { ActivatedRoute } from "@angular/router";
import { finalize } from "rxjs/operators";
import {
  CstFormBuilder,
  CstFormGroup,
} from "src/app/_uncategorised_models_services/cst-form-group";
import { FormControlBase } from "src/app/common-components/form-controls/form-control-base";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import {
  IVorgangCreateCommand,
  InfoportalFoldersClientProvider,
  RessourcenStatus,
  TagDto,
  ValidationResult,
  VorgangCreateCommand,
} from "src/app/web-api/web-api";

@Component({
    selector: "folder-insert",
    templateUrl: "./folder-create.component.html",
    styleUrls: ["./folder-create.component.scss"],
    standalone: false
})
export class InfoportalFolderCreateComponent extends CstResponsivePopupComponentBase {
  private _fb = inject(CstFormBuilder);
  private _client = inject(InfoportalFoldersClientProvider);
  private _route = inject(ActivatedRoute);

  facilityID: number = null;
  public form: CstFormGroup<IVorgangCreateCommand>;
  sliderColor: ThemePalette = "warn";
  public loading = false;

  public constructor() {
    super();
    this.form = this._fb.group<IVorgangCreateCommand>({
      anlagenID: new FormControl(0, Validators.required),
      bezeichnung: new FormControl("", [
        Validators.required,
        Validators.maxLength(75),
        Validators.minLength(2),
      ]),
      info: new FormControl("", Validators.maxLength(2000)),
      status: new FormControl(RessourcenStatus.Aktiv, Validators.required),
      tagIDs: new FormControl([]),
    });

    this._route.queryParams.subscribe((params) => {
      if (params.facilityID) {
        this.form.patchValue({ anlagenID: params.facilityID });
      }
    });
  }

  public onCancel() {
    this.close();
  }

  public onAccept() {
    if (!this.form.valid) {
      return;
    }
    this.loading = true;
    const cmd = new VorgangCreateCommand(this.form.value);
    cmd.bezeichnung = cmd.bezeichnung.trim();
    cmd.info = cmd.info?.trim() || null;
    this._client
      .vorgangCreate(cmd)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (result) => {
          this.close(result);
        },
        (error) => {
          console.log(error);
          if (error instanceof ValidationResult) {
            console.log(error);
            setTimeout(
              () =>
                FormControlBase.ApplyValidationResultToForm(this.form, error),
              200
            );
            return;
          }
          console.error(error);
        }
      );
  }
  public onTagSelected(tags: TagDto[]) {
    this.form.patchValue({ tagIDs: tags ? tags.map((x) => x.id) : [] });
  }
}
